import Typography from "@/foundation/Typography/V2";

import BootcampCarousel from "./BootcampCarousel";

import { classNameGenerator } from "@/utils";

import { useAppSelector } from "@/hooks";

import styles from "./BootcampListing.module.scss";

interface BootcampListingProps {}

const BootcampListing: React.FC<BootcampListingProps> = () => {
  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  const { bootcampList, bootcamps } = data || {};
  const { title, description } = bootcamps || {};

  if (bootcampList?.length === 0) {
    return <></>;
  }

  return (
    <section className={cls("bootcampListing")}>
      <div className={cls("container")}>
        <div className={cls("heading")}>
          <Typography variant="heading2" className={cls("title")}>
            {title}
          </Typography>
          <Typography variant="paragraph1" className={cls("description")}>
            {description}
          </Typography>
        </div>
        <div className={cls("content")}>
          <BootcampCarousel bootcamps={bootcampList} />
        </div>
      </div>
    </section>
  );
};

export default BootcampListing;
